<template lang="pug">
.metric
  .d-inline-flex.no-wrap.align-items-center
    .text-difference(:class="`${differenceClass} ${invertColor ? 'inverted' : ''}`")
      i.hi.caret.hi-10.mt-0(v-if="showCaret")
      .equal-sign(v-else-if="showEqualSign") =
    .metric-value(v-if="!customValue") {{ parsedValue }}
    .metric-value(v-else) {{ customValue }}
    .description(v-if="text")
      | {{ text }}
</template>

<script>
import { parseMetricValue, metricColorClass } from '~/utils/insights_utils';

export default {
  name: 'InsightsMetric',
  props: {
    value: {
      type: Number,
      default: null,
      validator: (v) => (typeof v === 'number') !== -1 || v === null || typeof v === 'string',
    },
    customValue: {
      type: [String, Number],
      default: null,
      validator: (v) => (typeof v === 'number') !== -1 || v === null || typeof v === 'string',
    },
    type: {
      type: String,
      default: 'percentage',
      validator: (value) => ['percentage', 'time', 'number', 'custom'].includes(value),
    },
    text: {
      type: String,
      default: '',
    },
    addon: {
      type: String,
      default: '',
    },
    invertColor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showCaret() {
      return ['positive', 'negative'].includes(this.differenceClass);
    },
    showEqualSign() {
      return this.differenceClass === 'same';
    },
    parsedValue() {
      return parseMetricValue(this.value, this.type);
    },
    differenceClass() {
      return metricColorClass(this.value);
    },
  },
};
</script>
